import {Vue} from '~/addiesaas'
import * as types from '../mutation-types/cart'
import axios from 'axios'

const namespaced = true
export const namespace = 'Cart'

const EventBus = window.VueEventBus

const trackIncomplete = window.addiesaas.orders ? window.addiesaas.orders.track_incomplete : false

// const helpers = {}

// state
const state = {
  attributes: {},
  items: {},
  discounts: {},
  billing: {
    firstName: '',
    lastName: '',
    country: '',
    email: '',
    phone: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',

    cardHolder: '',
    card: '',
    cvv: '',
    expMonth: '',
    expYear: '',

    bank: '',
    bankAddress: '',
    bankAccountHolder: '',
    bankAccount: '',
    bankCode: '',
  },
  incompleteOrderId: null,
}

const cartItem = {
  // ID of the item set during item adding
  id: null,

  // Title of the item
  title: '',

  // Product type: giftcart, reservation, etc.
  type: null,

  // Total cost of the item
  total: null,

  // Actual order item payload to be sent via API
  payload: {
    product_id: null,
    options: {},
    count: 1,
  },

  // Custom attributes of the item used during rendering
  attributes: {},

  // Show edit button
  editable: false,

  // Edit route
  editRoute: null,

  // Show delete button
  deletable: true,
}

const cartDiscount = {
  // ID of the discount set during discount adding
  id: null,

  // Title of the item
  title: '',

  // Discount type: giftcart, coupon, etc.
  type: null,

  // Total discount of the item
  total: null,

  // Actual order discount payload to be sent via API
  payload: {
    type: null,
    options: {},
  },

  // Custom attributes of the item used during rendering
  attributes: {},
}

// mutations
const mutations = {
  [types.ADD_TO_CART](state, item) {
    const fullItem = _.merge({}, cartItem, item)

    if (!fullItem.id) {
      fullItem.id = (new Date).getTime()
    }

    Vue.set(state.items, fullItem.id, fullItem)
  },

  [types.UPDATE_CART_ITEM](state, item) {
    const cartItem =  state.items[item.id] || null
    if (cartItem) {
      const fullItem = _.merge({}, cartItem, item)
      Vue.set(state.items, fullItem.id, fullItem)
    }
  },

  [types.ADD_DISCOUNT](state, discount) {
    const fullDiscount = _.merge({}, cartDiscount, discount)

    if (!fullDiscount.id) {
      fullDiscount.id = (new Date).getTime()
    }

    Vue.set(state.discounts, fullDiscount.id, fullDiscount)
  },

  [types.REMOVE_CART_DISCOUNT](state, {id}) {
    Vue.delete(state.discounts, id)
  },

  [types.CLEAR_CART](state, options) {
    const {location = null} = options || {}
    let items = {}
    let discounts = {}

    if (location) {
        items = _.omitBy(state.items, item => {
          const itemLocation = _.get(item, 'attributes.product.location_id', _.get(item, 'attributes.location_id'))
          return !itemLocation || itemLocation === location
        })
        const removedItems = _.pickBy(state.items, item => {
          const itemLocation = _.get(item, 'attributes.product.location_id', _.get(item, 'attributes.location_id'))
          return !itemLocation || itemLocation === location
        })
        //@todo: what are the ways we can remove discount by location or possibly remove discount if applied to a product of the location
        // discounts = _.omitBy(state.discounts, (discount, id) => {
        //
        // })
    }

    Vue.set(state, 'items', items)
    Vue.set(state, 'discounts', discounts)
  },

  [types.REMOVE_FROM_CART](state, {id}) {
    Vue.delete(state.items, id)
  },

  [types.SET_BILLING_DETAILS](state, items) {
    _.forOwn(items, (value, key) => {
      Vue.set(state.billing, key, value)
    })
  },

  [types.SET_CART_ITEM_COUNT](state, { id, count }) {
    if (state.items[id]) {
      Vue.set(state.items[id], 'count', count)
      Vue.set(state.items[id].payload, 'count', count)
    }
  },

  [types.SET_INCOMPLETE_ORDER_ID](state, { id }) {
    state.incompleteOrderId = id
  },
}

async function updateCartItem(commit, getters, dispatch, payload, silent = false) {
  const items = getters.cartItems
  try {
    await EventBus.$$emitAsync('cart.item.before.update', payload, items)
    commit(types.UPDATE_CART_ITEM, payload)
    await EventBus.$$emitAsync('cart.item.updated', payload, silent)
    await dispatch('pushIncompleteOrder')
    return true
  } catch (e) {
    EventBus.$emit('cart.item.update.failed', payload)
  }
  return false
}

const actions = {
  async addCartItem({commit, getters, dispatch}, payload) {
    try {
      await EventBus.$$emitAsync('cart.item.before.add', payload, getters.cartItems)
      commit(types.ADD_TO_CART, payload)
      await EventBus.$$emitAsync('cart.item.added', payload)
      await dispatch('pushIncompleteOrder')
      return true
    } catch (e) {
      EventBus.$emit('cart.item.add.failed', e, payload)
    }
    return false
  },

  async addCartItems({ dispatch }, payload) {
    for (const item of Object.values(payload)) {
      await dispatch('addCartItem', item)
    }
  },

  async updateCartItem({commit, getters, dispatch}, payload) {
    return await updateCartItem(commit, getters, dispatch, payload, false)
  },

  async updateCartItemSilent({commit, getters, dispatch}, payload) {
    return await updateCartItem(commit, getters, dispatch, payload, true)
  },

  addDiscount({commit}, payload) {
    commit(types.ADD_DISCOUNT, payload)
  },

  removeCartDiscount({commit}, payload) {
    commit(types.REMOVE_CART_DISCOUNT, payload)
  },

  async clearCart({ commit, dispatch }, payload) {
    EventBus.$emit('cart.clear.before', payload)
    commit(types.CLEAR_CART, payload)
    EventBus.$emit('cart.cleared', payload)
    await dispatch('deleteIncompleteOrder')
  },

  async removeCartItem({ commit, getters, dispatch }, payload) {
    EventBus.$emit('cart.item.before.remove', payload)
    commit(types.REMOVE_FROM_CART, payload)
    EventBus.$emit('cart.item.removed', payload)
    await dispatch('deleteIncompleteOrder')
    if (getters.cartItemCount) {
      await dispatch('pushIncompleteOrder')
    } else {
      await dispatch('deleteIncompleteOrder')
    }
  },

  setBillingDetails({commit}, payload) {
    commit(types.SET_BILLING_DETAILS, payload)
  },

  async setCartItemCount({ commit, dispatch }, payload) {
    commit(types.SET_CART_ITEM_COUNT, payload)
    await EventBus.$$emitAsync('cart.item.updated', payload)
    await dispatch('pushIncompleteOrder')
  },

  async pushIncompleteOrder({ commit, state }, payload = {}) {
    if (!trackIncomplete) {
      return
    }

    let apiUrl = `${window.addiesaas.config.apiUri}/customer/order-incomplete`

    if (state.incompleteOrderId != null) {
      apiUrl += `/${state.incompleteOrderId}`
    }

    const apiPayload = {
      state: payload.state || 'filling',
      items: state.items,
    }

    if ('order_id' in payload) {
      apiPayload.order_id = payload.order_id
    }

    const method = state.incompleteOrderId == null ? axios.post : axios.put
    const { data: { data } } = await method(apiUrl, apiPayload)

    if (data.id) {
      commit(types.SET_INCOMPLETE_ORDER_ID, { id: data.id })
    }
  },

  async deleteIncompleteOrder({commit, state}) {
    if (!trackIncomplete) {
      return
    }

    const incompleteOrderId = state.incompleteOrderId

    commit(types.SET_INCOMPLETE_ORDER_ID, { id: null })
    if (incompleteOrderId) {
      await axios.delete(`${window.addiesaas.config.apiUri}/customer/order-incomplete/${incompleteOrderId}`)
    }
  },

  async restoreIncompleteOrder({commit, state, dispatch}, payload) {
    const { data: { data } } = await axios.get(`${window.addiesaas.config.apiUri}/customer/order-incomplete/${payload.id}`)

    if (state.incompleteOrderId == data.id) {
      commit(types.CLEAR_CART)
    } else {
      dispatch('clearCart')
      commit(types.SET_INCOMPLETE_ORDER_ID, { id: data.id })
    }

    for (const item of Object.values(data.items)) {
      item.payload.options.incomplete_order_id = data.id
      commit(types.ADD_TO_CART, item)
    }

    return data
  },
}

// getters
const getters = {
  // ...mapGetters(state.form),
  cartItemStub: state => cartItem,
  cart: state => state,
  cartItems: state => state.items,
  cartDiscounts: state => state.discounts,
  cartItemCount: (state, getters) => Object.keys(getters.cartItems || {}).length,
  cartIsEmpty: (state, getters) => _.isEmpty(getters.cartItems),
  cartItem(state, getters)
   {
    return function (item) {
      return state.items[item]
    }
  },
  billingDetails(state, getters){
    return function (item) {
      if (!item) {
        return state.billing
      }
      return state.billing[item]
    }
  },
}

// plugins
const plugins = []

const cart = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default cart
